import { Component, OnInit, Input } from '@angular/core';
import { RegisterService } from 'src/app/services/register/register.service';
import {BackdropService} from "../../services/backdrop/backdrop.service";
import {faCircleNotch} from "@fortawesome/free-solid-svg-icons";
import {transition, trigger} from "@angular/animations";

@Component({
    selector: 'xqnr-pending-verification',
    templateUrl: './pending-verification.component.pug',
    styleUrls: ['./pending-verification.component.scss'],
    animations: [
        trigger('showHide', [
            transition(':enter', []),
            transition(':leave', [])
        ])
    ],
    standalone: false
})
export class PendingVerificationComponent implements OnInit {
  @Input() email: string;
  success = false;
  error = false;
  spinning = false;
  fa = {
    circleNotch: faCircleNotch
  };

  constructor(
    private register: RegisterService,
    private backdrop: BackdropService,
  ) {}

  ngOnInit() {
    this.backdrop.active$.subscribe((activeState: boolean) => {
      if (!activeState) this.register.hide();
    });
  }

  resendLinkSuccess = (data) => {
    this.spinning = false;
    this.success = true;
  };

  resendLinkError = (err) => {
    this.spinning = false;
    console.error(err);
    this.error = true;
  };

  resendLink() {
    if (this.success) return;
    this.spinning = true;
    this.error = false;
    this.register.resendLinkByEmail(this.email).subscribe(
      this.resendLinkSuccess,
      this.resendLinkError
    );
  }
}
